<script lang="ts">
    import type {Photo} from "./Types";
    import {authBlobUrl} from "../../Auth";
    import Minithumbnail from "./Minithumbnail.svelte";
    import InView from "../InView.svelte";

    export let entity: Photo
    export let telegramUserId: string
    export let telegramChatId: string
    export let telegramMessageId: string
    export let isChannel: string

    let src = null
    let fullScreen: boolean = false
    let photoIndex: number = 0
    let loading: boolean = false
    let failed: boolean = false

    // Викликається автоматично, коли фото потрапляє в поле зору (InView), або кліком для повторної спроби
    async function loadFullImage() {
        if (src !== null || loading) {
            return true
        }
        let index = 0
        if (isChannel != 1) {
            index = entity.sizes.length - 1
        }
        let photoId = entity.sizes[index]?.photo?.id ?? null
        let remotePhotoId = entity.sizes[index]?.photo?.remote?.id ?? ''

        if (photoId === null) {
            console.warn('without photo id')
            return false;
        }
        loading = true
        failed = false
        try {
            src = await authBlobUrl(`/user/${telegramUserId}/chat/${telegramChatId}/message/${telegramMessageId}/attachment/${photoId}/${remotePhotoId}`)
            photoIndex = index
        } catch (error) {
            failed = true
        } finally {
            loading = false
        }
    }
</script>

<Minithumbnail entity="{entity.minithumbnail}"/><br/>
<InView on:visible={loadFullImage}>
{#if (src==null)}
    <div on:click={loadFullImage}
         class="img-thumbnail position-relative"
         style:height={entity.sizes[0].height + 'px'}
         style:width={entity.sizes[0].width + 'px'}
         style:background="no-repeat center center"
         style:background-size="contain"
         style:background-image={entity.minithumbnail?.data ? `url(data:image/png;base64,${entity.minithumbnail?.data})` : null}>
        {#if loading}
            <div class="spinner-grow position-absolute top-0 bottom-0 end-0 start-0 m-auto"></div>
        {:else}
            <div class="rounded-circle text-center align-middle position-absolute top-0 bottom-0 end-0 start-0 m-auto"
                 style="height: 50px; width: 50px; cursor: pointer; background: rgba(255, 255, 255, 0.7)">
                <i class="bi bi-arrow-bar-down h1"></i>
            </div>
            {#if failed}
                <div class="position-absolute bottom-0 start-0 end-0 text-center small bg-light">Повнорозмірне зображення відсутнє</div>
            {/if}
        {/if}
    </div>
{:else if (!fullScreen)}
    <div on:click={()=>fullScreen=!fullScreen}
         class="img-thumbnail"
         style:height={entity.sizes[0].height + 'px'}
         style:width={entity.sizes[0].width + 'px'}
         style:background="no-repeat center center"
         style:background-size="contain"
         style:background-image={`url(${src})`}
    ></div>
{:else}
    <div on:click={()=>fullScreen=!fullScreen} on:keypress={()=>fullScreen=!fullScreen}
         class="position-fixed top-0 end-0 bottom-0 start-0 overflow-auto"
         style="background: rgba(0, 0, 0, 0.75); z-index: 1040;">
        <button class="btn btn-secondary rounded-circle position-absolute"
                style="top: 75px; right: 20px;">
            <i class="bi bi-x"></i>
        </button>
        <div class="img-thumbnail position-absolute top-0 end-0 bottom-0 start-0 m-auto"
             style:height={entity.sizes[photoIndex].height + 'px'}
             style:width={entity.sizes[photoIndex].width + 'px'}
             style:background="no-repeat center center"
             style:background-size="contain"
             style:background-image={`url(${src})`}
        ></div>
    </div>
{/if}
</InView>
